// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uni-nav-link {
  color: #FFFFFF !important;
  font-size: 16px;
  font-weight: 400;
  line-height: 25px;
  text-align: center;
}

.uni-nav-link.active {
  color: white !important;
  text-decoration: underline;
  text-underline-offset: 6px;
  text-decoration-thickness: 3px;
  border-radius: 8px;
}

.nav-link:hover {
  color: white !important;
  text-underline-offset: 6px;
  text-decoration-thickness: 3px !important;
  text-decoration: underline;
  border-radius: 8px;

}

.navbar-nav .nav-link.active {
  color: white !important;
  text-decoration: underline;
  text-underline-offset: 6px;
  text-decoration-thickness: 3px;
  border-radius: 8px;

}

.navbar .navbar-toggler {
  top: .75rem;

}



.nav-link {
  padding: 0px 15px;

}


.dropdown-toggle.nav-link {
  color: #FFFFFF !important;
}

.user-profile {
  display: inline-block !important;
  color: #FFFFFF !important;
}

.user-profile .nav-link:hover {
  background-color: #005EEF;
  padding: 0px 15px;
  text-decoration: none;
}

.unl-div-logo {
  display: inline-flex;
  padding: 9px 0px 8px 0px;
  justify-content: flex-end;
  align-items: center;
  gap: 9px;
}



.custom-dropdown-menu {

  right: 0;
  left: auto
}



.uniBtnYellow {
  padding: 3px 12px;
  align-items: center;
  background: #FFE300;
}

.uniBtnYellow:hover {
  background-color: #FCEDA4;
}


@media (min-width: 1300px) {
  .list-container {
    gap: 22px;
    margin-right: 20%;
  }

  .uniBtnYellow {
    font-size: 14px;
  }

}

@media(max-width:1300px) {
  .dropdown-item,
  .uniBtnYellow,
  .user-profile,
  .uni-nav-link {
    font-size: 12px;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,yCAAyC;EACzC,0BAA0B;EAC1B,kBAAkB;;AAEpB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,8BAA8B;EAC9B,kBAAkB;;AAEpB;;AAEA;EACE,WAAW;;AAEb;;;;AAIA;EACE,iBAAiB;;AAEnB;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;AACV;;;;AAIA;;EAEE,QAAQ;EACR;AACF;;;;AAIA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE;IACE,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE;;;;IAIE,eAAe;EACjB;;AAEF","sourcesContent":[".uni-nav-link {\n  color: #FFFFFF !important;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 25px;\n  text-align: center;\n}\n\n.uni-nav-link.active {\n  color: white !important;\n  text-decoration: underline;\n  text-underline-offset: 6px;\n  text-decoration-thickness: 3px;\n  border-radius: 8px;\n}\n\n.nav-link:hover {\n  color: white !important;\n  text-underline-offset: 6px;\n  text-decoration-thickness: 3px !important;\n  text-decoration: underline;\n  border-radius: 8px;\n\n}\n\n.navbar-nav .nav-link.active {\n  color: white !important;\n  text-decoration: underline;\n  text-underline-offset: 6px;\n  text-decoration-thickness: 3px;\n  border-radius: 8px;\n\n}\n\n.navbar .navbar-toggler {\n  top: .75rem;\n\n}\n\n\n\n.nav-link {\n  padding: 0px 15px;\n\n}\n\n\n.dropdown-toggle.nav-link {\n  color: #FFFFFF !important;\n}\n\n.user-profile {\n  display: inline-block !important;\n  color: #FFFFFF !important;\n}\n\n.user-profile .nav-link:hover {\n  background-color: #005EEF;\n  padding: 0px 15px;\n  text-decoration: none;\n}\n\n.unl-div-logo {\n  display: inline-flex;\n  padding: 9px 0px 8px 0px;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 9px;\n}\n\n\n\n.custom-dropdown-menu {\n\n  right: 0;\n  left: auto\n}\n\n\n\n.uniBtnYellow {\n  padding: 3px 12px;\n  align-items: center;\n  background: #FFE300;\n}\n\n.uniBtnYellow:hover {\n  background-color: #FCEDA4;\n}\n\n\n@media (min-width: 1300px) {\n  .list-container {\n    gap: 22px;\n    margin-right: 20%;\n  }\n\n  .uniBtnYellow {\n    font-size: 14px;\n  }\n\n}\n\n@media(max-width:1300px) {\n  .dropdown-item,\n  .uniBtnYellow,\n  .user-profile,\n  .uni-nav-link {\n    font-size: 12px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
